import { endOfDay, endOfMonth, endOfWeek } from 'date-fns';
import { useCallback } from 'react';
import type { Mode } from '../../../../types';

export const useGetEndDate = () =>
  useCallback(({ date, mode }: { date: Date; mode: Mode }) => {
    switch (mode) {
      case 'day':
        return endOfDay(date);
      case 'month':
        return endOfWeek(endOfMonth(date));
      case 'week':
        return endOfWeek(date);
    }
  }, []);
